<div class="page-wraper">

    <!-- HEADER START -->
    <app-header1></app-header1>
    <!-- HEADER END -->


    <!-- CONTENT START -->
    <div class="page-content">

        <!-- INNER PAGE BANNER -->
        <app-page-banner class="small-banner" title="Profiles of the Professionals" subtitle="Profiles of the Professionals"></app-page-banner>
        <!-- INNER PAGE BANNER END -->


        <!-- PRICING TABLE SECTION START -->
        <!-- <app-pricing1 [data]="pricing"></app-pricing1> -->
        <!-- PRICING TABLE SECTION END -->


        <!-- PRICING TABLE SECTION START -->
        <!-- <app-pricing2 [data]="pricing"></app-pricing2> -->
        <!-- PRICING TABLE SECTION END -->
        <!-- <div class="container pt-2 pb-5 mob-news">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-12 m-b10">
                    <div class="image-container text-center mt-5 mb-5">
                        <img src="assets/images/flat-lay-of-autumnal-maple-leaves-in-circle-isolat-2024-11-19-12-51-53-utc.jpg" alt="Who Are We" class="img-fluid rounded-img shadow-img">
                    </div>
                </div>

                <div class="col-lg-6 col-md-12">
                    <div class="text-content mobcontent" style="margin-top: -253px;" >
                        <div class="separator-line mt-5 mb-4 mobteam1"></div>
                        <p>
                            Soul Space was founded with the belief that mental wellness is a journey, not a destination. Our founder, Dr Raman Sodhi, envisioned a place where individuals could find holistic support for their mental health and well-being with utmost confidentiality and dignity.
                        </p>


                    </div>
                </div>
            </div>
        </div> -->


        <div class="container pt-2 pb-5 mob-news">
            <div class="row align-items-center">
                <!-- Left Side: Image -->
                <div class="col-lg-6 col-md-12 m-b10">
                    <!-- <h6 style="font-size: 32px">Profiles of the Professionals </h6> -->

                    <div class="image-container text-center mt-5 mb-5 mobcontent">
                        <img src="assets/images/our-team-image.jpg" alt="Who Are We" class="img-fluid rounded-img shadow-img" style="position: relative; bottom: -17px;">
                    </div>
                </div>

                <!-- Right Side: Text Content -->
                <div class="col-lg-6 col-md-12">
                    <div class="text-content mobcontent">
                        <div class="separator-line mt-5 mb-4"></div>
                        <h6>Dr Tanu (Psychiatrist)</h6>
                        <p>
                            Dr. Tanu Kumari is a skilled psychiatrist with over 3 years of experience in neurobiological psychiatry and psychosocial interventions. She completed her MBBS at Lady Hardinge Medical College, New Delhi, and her MD at AIIMS Bhubaneswar. Dr. Kumari has worked at top institutions including AIIMS Delhi, AIIMS Patna, and now serves as a consultant psychiatrist at Soul space. She is known for her compassionate approach to patient care and has contributed to psychiatric research and education. Dr. Kumari holds certifications in biomedical research, mental healthcare law, and child and adolescent psychiatry.
                        </p>


                    </div>
                </div>
            </div>
        </div>


        <div class="container pt-2 pb-5 mob-news">
            <div class="row align-items-center">
                <!-- Left Side: Image -->
                <div class="col-lg-6 col-md-12 m-b10">
                    <!-- <h6 style="font-size: 32px">Profiles of the Professionals</h6> -->

                    <div class="image-container text-center  mt-5 mb-5 mobcontent">
                        <img src="assets/images/our-team-image1.jpg" alt="Who Are We" class="img-fluid rounded-img shadow-img image-con" style="position: relative; top: -73px;">
                    </div>
                </div>

                <!-- Right Side: Text Content -->
                <div class="col-lg-6 col-md-12">
                    <div class="text-content mobcontent">
                        <div class="separator-line mt-5 mb-4 mobteam1"></div>
                        <h6>Capt. Amita Chaudhary (Clinical Psychologist)</h6>
                        <p>
                            Capt. Amita is an RCI-registered Clinical Psychologist with extensive expertise in the identification and diagnosis of a wide range of mental health disorders. She specialize in the planning and implementation of individualized psychotherapeutic treatments tailored to clients’ specific concerns. Proficient in conducting IQ and psycho-diagnostic assessments, she have experience working with diverse clinical populations, including children, adolescents, adults, and geriatric clients.</p>

                           <p> Trained in Cognitive Behavioral Therapy (CBT), Rational Emotive Behavior Therapy (REBT), Dialectical Behavior Therapy (DBT), and addiction counseling, Amita possess a deep understanding of various mental health disorders. Her approach emphasizes client education and evidence-based treatment. As an effective motivator and communicator, she excel in managing different personality types, diffusing stressful situations, and proactively addressing issues affecting clients' mental well-being.</p>
                                                   


                    </div>
                </div>
            </div>
        </div>


        <div class="container pt-2 pb-5 mob-news">
            <div class="row align-items-center">
                <!-- Left Side: Image -->
                <div class="col-lg-6 col-md-12 m-b10">
                    <!-- <h6 style="font-size: 32px">Profiles of the Professionals</h6> -->

                    <div class="image-container text-center mt-5 mb-5">
                        <img src="assets/images/our-team2.jpg" alt="Who Are We" class="img-fluid rounded-img shadow-img" style="position: relative; top: 11px;">
                    </div>
                </div>

                <!-- Right Side: Text Content -->
                <div class="col-lg-6 col-md-12">
                    <div class="text-content">
                        <div class="separator-line mt-5 mb-4 mobteam1"></div>
                        <h6>Mamta Singla (General Psychologist)</h6>
                        <p>
                            Mamta Singla has been practicing as a Psychologist in Gurugram from last 22 + years and have taken around 5000 + patients. She has extensively worked with cases of depression, anxiety, stress, personal loss and grief as well as anger management issues along with providing valuable marriage and relationship counselling. She deals with diverse population and is trained in comprehensive psychiatric casework. She also has expertise in conducting individual psychotherapy, including cognitive-behavioural therapy, supportive psychotherapy, family therapy, and crisis intervention.
                        </p>


                    </div>
                </div>
            </div>
        </div>


        <!-- <div class="container pt-2 pb-5 mob-news">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-12 m-b10">

                    <div class="image-container text-center mt-5 mb-5">
                        <img src="assets/images/our-team3.jpg" alt="Who Are We" class="img-fluid rounded-img shadow-img" style="position: relative; top: 5px;">
                    </div>
                </div>

                <div class="col-lg-6 col-md-12">
                    <div class="text-content">
                        <div class="separator-line mt-5 mb-4 mobteam1"></div>
                        <h6>Prerana Rathi (General Psychologist)</h6>
                        <p>
                            A skilled and compassionate psychotherapist dedicated to fostering mental well-being and personal transformation. With extensive experience working with individuals, couples, and families, I specialize in addressing anxiety, depression, trauma, and relationship challenges. My approach is client-centered and integrative, creating a safe, supportive space for healing and growth.</p>
                           <p> Committed to mental health advocacy, I actively work to destigmatize therapy and promote accessible care through workshops, consultations, and community initiatives.
                        </p>


                    </div>
                </div>
            </div>
        </div> -->

        <div class="container pt-2 pb-5 mob-news">
            <div class="row align-items-center">
                <!-- Left Side: Image -->
                <div class="col-lg-6 col-md-12 m-b10">
                    <!-- <h6 style="font-size: 32px">Profiles of the Professionals</h6> -->

                    <div class="image-container text-center mt-5 mb-5">
                        <img src="assets/images/our-team4.jpg" alt="Who Are We" class="img-fluid rounded-img shadow-img" style="position: relative; top: 5px; height: 250px; width: 41%;">
                    </div>
                </div>

                <!-- Right Side: Text Content -->
                <div class="col-lg-6 col-md-12">
                    <div class="text-content">
                        <div class="separator-line mt-5 mb-4 mobteam1"></div>
                        <h6>Gunjan Jain (Dietitian)</h6>
                        <p>
                            Dietitian Gunjan Jain is a clinical nutritionist with 12 years of experience, dedicated to transforming lives through the power of food. With expertise in therapeutic diets, she has helped countless individuals reverse medical conditions, improve gut health, and achieve holistic wellness.</p>
                           <p> She believes in the healing power of food and trusts that with the right nutrition, the body can restore itself naturally. She approaches every client with positivity, affirming "I can do anything", and ensures they feel empowered on their health journey.
                        </p>


                    </div>
                </div>
            </div>
        </div>


        



    </div>
    <!-- CONTENT END -->

    <app-footer1></app-footer1>

</div>

<app-loader></app-loader>